import React from 'react';
import almazen from '../../assets/img/tgle-almazen-black.png';


const  Almazen = ()=>{
    return <div style={{ textAlign:'center', paddingTop:'50px' }}><img alt='logo' src={almazen } style={{maxWidth:'80%'}} /></div>;
};

export default Almazen;
